import React from "react";
import styles from "./dotSeparator.module.scss";
/**
 * The small delimiter circle that separates facts inside a title bar or chrome row — header
 * details, tab-count labels, subtitle and legend rows. Plain running text separates facts with
 * the `·` character instead, never this circle. Sits in a flex or grid row; the parent owns the
 * surrounding gap.
 */
const DotSeparator = () => (React.createElement("span", { className: styles.dot, "aria-hidden": "true" }));
export default DotSeparator;
//# sourceMappingURL=DotSeparator.js.map